import {i18n, locale} from '@src/utils/i18n';
import * as nls from './nls';

const I18N = i18n(nls);
const openAddress = /localhost/.test(window.location.hostname) ? 'https://open.gamma.welink.huawei.com' : ''
let navMenuData = [
  {
    "id": "devbench-app-dev",
    "curPage": null,
    "pageSize": null,
    "menuName": I18N['appDev'],
    "resCode": "app-dev",
    "resUrl": "#/1/wecode",
    "isHref": "0",
    "resBelong": "public",
    "resType": "1",
    "parentResId": "0",
    "domain": 9,
    "parentResName": null,
    "sortNo": 0,
    "image": null,
    "description": "test",
    "tenantId": null,
    "isAdminView": 0,
    "menuUrl": "#/1/wecode",
    "subResList": null,
    "isShowMenu": 1
  },
  {
    "id": "devbench-app-connect",
    "curPage": null,
    "pageSize": null,
    "menuName": I18N['appConnect'],
    "resCode": "app-dev",
    "resUrl": "#/wecode/myconnectors",
    "isHref": "0",
    "resBelong": "public",
    "resType": "1",
    "parentResId": "0",
    "domain": 9,
    "parentResName": null,
    "sortNo": 0,
    "image": null,
    "description": "test",
    "tenantId": null,
    "isAdminView": 0,
    "menuUrl": "#/wecode/myconnectors",
    "subResList": null,
    "isShowMenu": 1
  },
  {
    "id": "devbench-dev-doc",
    "curPage": null,
    "pageSize": null,
    "menuName": I18N['devDocs'],
    "resCode": "app-dev",
    "resUrl": `${openAddress}/docs/#/990hh0/whokyc/vwd3yr`,
    "resType": "1",
    "resBelong": "public",
    "parentResId": "0",
    "isHref": "2",
    "parentResName": null,
    "sortNo": 0,
    "image": null,
    "description": "test",
    "domain": 9,
    "tenantId": null,
    "isAdminView": 0,
    "menuUrl": `${openAddress}/docs/#/990hh0/whokyc/vwd3yr`,
    "subResList": null,
    "isShowMenu": 1
  },
  {
    "id": "devbench-help",
    "curPage": null,
    "pageSize": null,
    "menuName": I18N['searchHelp'],
    "resCode": "app-dev",
    "resUrl": "https://bbs.huaweicloud.com/forum/forum-964-1.html",
    "resType": "1",
    "isHref": "2",
    "resBelong": "public",
    "parentResId": "0",
    "parentResName": null,
    "image": null,
    "sortNo": 0,
    "description": "test",
    "tenantId": null,
    "domain": 9,
    "isAdminView": 0,
    "menuUrl": "https://bbs.huaweicloud.com/forum/forum-964-1.html",
    "subResList": null,
    "isShowMenu": 0
  },
];

export default navMenuData
